import { createRouter, createWebHistory } from "vue-router";
import * as Mutations from "@/store/mutations.type";
import store from "@/store";
import { firebaseAuth } from "@/common/firebase";

// layouts
import Admin from "@/layouts/Admin.vue";
import Auth from "@/layouts/Auth.vue";

// views for Auth layout
import Login from "@/views/auth/Login.vue";

const routes = [
  {
    path: "/auth",
    name: "auth",
    redirect: "/auth/login",
    component: Auth,
    children: [
      {
        path: "/auth/login",
        name: "login",
        component: Login
      }
    ]
  },
  {
    path: "/",
    name: "admin",
    redirect: "/admin/dashboard",
    component: Admin,
    meta: { requiresAuth: true },
    children: [
      {
        path: "/admin/dashboard",
        name: "dashboard",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/admin/Dashboard.vue")
      },
      {
        path: "/admin/profile",
        name: "profile",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/admin/Profile.vue")
      }
    ]
  },
  {
    path: "/component",
    name: "component",
    redirect: "/component/category-page",
    component: Admin,
    meta: { requiresAuth: true },
    children: [
      {
        path: "/component/category-page",
        name: "category-page",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/component/CategoryPageInstanceList.vue"
          )
      },
      {
        path: "/component/blog-page",
        name: "blog-page",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/component/BlogPageInstanceList.vue"
          )
      },
      {
        path: "/component/email-delay-message",
        name: "email-delay-message",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/component/EmailDelayNoticePage.vue"
          )
      },
      {
        path: "/component/blog-page/create",
        name: "blog-create",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/component/BlogPage.vue"
          )
      },
      {
        path: "/component/blog-page/edit/:instanceId",
        name: "blog-edit",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/component/BlogPage.vue"
          )
      },
      {
        path: "/component/category-page/edit/:categoryName",
        name: "category-edit",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/component/CategoryPage.vue"
          )
      },
      {
        path: "/component/category-page/create/:categoryName",
        name: "category-create",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/component/CategoryPage.vue"
          )
      },
      {
        path: "/component/:id",
        name: "instance-list",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/component/ComponentInstanceList.vue"
          ),
        props: true
      },
      {
        path: "/component/edit/:compId/:instanceId",
        name: "component-edit",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/component/ComponentInstance.vue"
          ),
        props: true
      },
      {
        path: "/component/create/:compId/",
        name: "component-create",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/component/ComponentInstance.vue"
          ),
        props: true
      }
    ]
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/"
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

// authenticate
router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some((x) => x.meta.requiresAuth);

  if (requiresAuth && !firebaseAuth.currentUser) {
    router.push({ name: "auth" });
  } else {
    if (firebaseAuth.currentUser) {
      store.commit(Mutations.SET_AUTH, firebaseAuth.currentUser);
    }
    next();
  }
});

export default router;
